import { render, staticRenderFns } from "./RecruitTempMore.vue?vue&type=template&id=bf0c131c&scoped=true&"
import script from "./RecruitTempMore.vue?vue&type=script&lang=js&"
export * from "./RecruitTempMore.vue?vue&type=script&lang=js&"
import style0 from "./RecruitTempMore.vue?vue&type=style&index=0&id=bf0c131c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0c131c",
  null
  
)

export default component.exports